@if (showOutsourcingForm()) {
  <section class="edit-outsourcing">
    <onyx-divider variant="modal" edge="top"></onyx-divider>

    <div class="form">
      <onyx-information-heading align="center">
        {{ `orders.orderModal.outsourcingForm.editOutsourcing` | translate }}

        <app-order-modal-deadline-message
          subheading
          [order]="order()"
        ></app-order-modal-deadline-message>
      </onyx-information-heading>

      <app-order-modal-outsourcing-form
        [order]="order()"
        [mode]="OnyxFormMode.EDIT"
        [close$]="close$()"
        (cancelEdit)="showOutsourcingForm.set(false)"
      ></app-order-modal-outsourcing-form>
    </div>

    <onyx-divider variant="modal" edge="bottom"></onyx-divider>
  </section>
} @else {
  <onyx-information-heading>
    <div class="title">
      <onyx-icon name="cursor-filled" [size]="20"></onyx-icon>

      {{ 'labels.outsourcing' | translate }}
    </div>

    <ng-container actions>
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="download-outlined"
        [circle]="true"
        onyxTooltip="labels.downloadPdf"
        (click)="createPdf()"
      ></onyx-icon-button>

      <onyx-icon-button
        color="gray"
        variant="transparent"
        [size]="32"
        icon="history-outlined"
        [circle]="true"
        onyxTooltip="labels.vehicleAndDriverHistory"
        (click)="openActivityModal()"
      ></onyx-icon-button>

      <onyx-icon-button
        color="gray"
        variant="transparent"
        [size]="32"
        icon="options-vertical-filled"
        [circle]="true"
        [onyxDropdownOptions]="OPTIONS"
        (onyxDropdownSelectedValueChange)="$event.value?.()"
        onyxTooltip="labels.options"
        (click)="$event.stopPropagation()"
      ></onyx-icon-button>

      <div class="pdf" #pdfContent>
        <app-order-pdf-template [order]="order()"></app-order-pdf-template>
      </div>
    </ng-container>
  </onyx-information-heading>

  @let outsourcingData = order().outsourcingData!;
  <div class="container">
    <onyx-data-widget
      supheading="labels.contractor"
      [clickable]="true"
      (click)="openContractorModal()"
    >
      <div class="options-container" heading>
        <p>{{ outsourcingData.contractor.companyProfile.displayName }}</p>
      </div>
    </onyx-data-widget>

    <onyx-data-widget supheading="labels.contactPerson">
      <div class="options-container" heading>
        @let contactPerson = outsourcingData.contactPerson;
        <p>{{ contactPerson | onyxName }}</p>

        @if (contactPerson) {
          <div class="options">
            <onyx-icon-button
              variant="transparent"
              color="gray"
              [size]="24"
              icon="envelope-outlined"
              onyxTooltip="labels.sendEmail"
              (click)="ActionHelper.sendEmail(contactPerson.email)"
            ></onyx-icon-button>

            <onyx-icon-button
              variant="transparent"
              color="gray"
              [size]="24"
              icon="telephone-outlined"
              onyxTooltip="labels.call"
              (click)="ActionHelper.makeCall(contactPerson.phone)"
            ></onyx-icon-button>
          </div>
        }
      </div>
    </onyx-data-widget>

    <onyx-data-widget supheading="labels.vehicles">
      <div heading class="wrapper">
        <span class="icon-wrapper sea-green">
          <onyx-icon name="semi-truck-filled" [size]="20"></onyx-icon>
          {{ outsourcingData.vehicleRegistrationNumber | fleetIdentifier }}
        </span>

        @let basicInformation = order().basicInformation;
        @if (basicInformation.loadedSemiTrailer.data; as loadedSemiTrailer) {
          <div class="icon-wrapper">
            <app-order-loaded-trailer-icon
              color="black"
              [size]="20"
            ></app-order-loaded-trailer-icon>

            <app-module-link
              module="fleet"
              color="black"
              font="f-heading-m"
              (linkClick)="openFleetModal(loadedSemiTrailer)"
            >
              {{ loadedSemiTrailer | fleetIdentifier }}
            </app-module-link>
          </div>
        } @else if (
          basicInformation?.loadedSemiTrailer.registrationNumber;
          as trailerRegistration
        ) {
          <div class="icon-wrapper">
            <app-order-loaded-trailer-icon
              color="sea-green"
              [size]="20"
            ></app-order-loaded-trailer-icon>

            <span class="sea-green">
              {{ trailerRegistration | fleetIdentifier }}
            </span>
          </div>
        } @else if (
          outsourcingData.trailerRegistrationNumber;
          as outsourcingTrailerRegistration
        ) {
          <span class="icon-wrapper sea-green">
            <onyx-icon name="semi-trailer-filled" [size]="20"></onyx-icon>
            {{ outsourcingTrailerRegistration | fleetIdentifier }}
          </span>
        }
      </div>
    </onyx-data-widget>

    <onyx-data-widget supheading="labels.drivers">
      <div heading class="wrapper">
        <app-order-outsourcing-driver
          [driver]="outsourcingData.primaryDriver"
        ></app-order-outsourcing-driver>

        @if (outsourcingData.secondaryDriver; as secondaryDriver) {
          <app-order-outsourcing-driver
            [driver]="secondaryDriver"
          ></app-order-outsourcing-driver>
        }
      </div>
    </onyx-data-widget>
  </div>
}
